import React from "react";

import { NavLink } from "react-router-dom";

import { NavbarProps } from "../Modules/modules";
import { Demo_Logo_SVG } from "../utils/Helpers/SvgImages/demoLogo";
// import { Demo_Logo_SVG } from "../utils/Helper/helper";

const Navbar = (props: NavbarProps) => {
  
  return (
    <div className="sunnyHeath_nav">

      <nav
        className={`navbar navbar-light bg-light d-flex justify-content-between ${
          !props.isHeliosIframeOpen ? "navbar-expand-lg" : ""
        }`}
      >
        <div
          className={`set-clox ${
            props.isHeliosIframeOpen ? "isheliosOpen" : ""
          }`}
        >
          <NavLink className="navbar-brand" to={props.route}>
            {Demo_Logo_SVG()}
          </NavLink>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
        </div>

        <div
          className={`navbar_content set  ${
            props.isHeliosIframeOpen && "heliosIframeExtent"
          }`}
          style={{ top: props.isHeliosIframeOpen && 94 }}
        >
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul
              className="navbar-nav mr-auto responsive-nav "
              // style={{ marginRight: props.marginRight }}
              style={{
                alignItems: props.isHeliosIframeOpen ? "flex-start" : "center",
              }}
            >
              <li
                className={`nav-item dropdown ${
                  props.isHeliosIframeOpen ? "isHelios-item" : ""
                }`}
              >
                <a
                  className="nav-link"
                  href="#"
                  role="button"
                  data-toggle="dropdown"
                  aria-expanded="false"
                >
                  Profile
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_4467_519)">
                      <path
                        d="M13.825 7.15833L10 10.975L6.175 7.15833L5 8.33333L10 13.3333L15 8.33333L13.825 7.15833Z"
                        fill="#00B0F0"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_4467_519">
                        <rect width="20" height="20" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
                <div className="dropdown-menu">
                  <a className="dropdown-item" href="#">
                    Action
                  </a>
                  <a className="dropdown-item" href="#">
                    Another action
                  </a>
                  <div className="dropdown-divider"></div>
                  <a className="dropdown-item" href="#">
                    Something else here
                  </a>
                </div>
              </li>{" "}
              <li
                className={`nav-item dropdown ${
                  props.isHeliosIframeOpen ? "isHelios-item" : ""
                }`}
              >
                <a
                  className="nav-link"
                  href="#"
                  role="button"
                  data-toggle="dropdown"
                  aria-expanded="false"
                >
                  Benefits
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_4467_519)">
                      <path
                        d="M13.825 7.15833L10 10.975L6.175 7.15833L5 8.33333L10 13.3333L15 8.33333L13.825 7.15833Z"
                        fill="#00B0F0"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_4467_519">
                        <rect width="20" height="20" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
                <div className="dropdown-menu">
                  <a className="dropdown-item" href="#">
                    Action
                  </a>
                  <a className="dropdown-item" href="#">
                    Another action
                  </a>
                  <div className="dropdown-divider"></div>
                  <a className="dropdown-item" href="#">
                    Something else here
                  </a>
                </div>
              </li>
              <li
                className={`nav-item dropdown ${
                  props.isHeliosIframeOpen ? "isHelios-item" : ""
                }`}
              >
                <a
                  className="nav-link"
                  href="#"
                  role="button"
                  data-toggle="dropdown"
                  aria-expanded="false"
                >
                  Quick Links
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_4467_519)">
                      <path
                        d="M13.825 7.15833L10 10.975L6.175 7.15833L5 8.33333L10 13.3333L15 8.33333L13.825 7.15833Z"
                        fill="#00B0F0"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_4467_519">
                        <rect width="20" height="20" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
                <div className="dropdown-menu">
                  <a className="dropdown-item" href="#">
                    Action
                  </a>
                  <a className="dropdown-item" href="#">
                    Another action
                  </a>
                  <div className="dropdown-divider"></div>
                  <a className="dropdown-item" href="#">
                    Something else here
                  </a>
                </div>
              </li>
              <li
                className={`nav-item dropdown ${
                  props.isHeliosIframeOpen ? "isHelios-item" : ""
                }`}
              >
                <a
                  className="nav-link"
                  href="#"
                  role="button"
                  data-toggle="dropdown"
                  aria-expanded="false"
                >
                  About
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_4467_519)">
                      <path
                        d="M13.825 7.15833L10 10.975L6.175 7.15833L5 8.33333L10 13.3333L15 8.33333L13.825 7.15833Z"
                        fill="#00B0F0"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_4467_519">
                        <rect width="20" height="20" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
                <div className="dropdown-menu">
                  <a className="dropdown-item" href="#">
                    Action
                  </a>
                  <a className="dropdown-item" href="#">
                    Another action
                  </a>
                  <div className="dropdown-divider"></div>
                  <a className="dropdown-item" href="#">
                    Something else here
                  </a>
                </div>
              </li>
              <li
                className={`nav-item dropdown ${
                  props.isHeliosIframeOpen ? "isHelios-item" : ""
                }`}
              >
                <a
                  className="nav-link"
                  href="#"
                  role="button"
                  data-toggle="dropdown"
                  aria-expanded="false"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    className="nickname_svg"
                  >
                    <mask
                      id="mask0_4309_9670"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="25"
                      height="24"
                    >
                      <rect x="0.5" width="24" height="24" fill="#00B0F0" />
                    </mask>
                    <g mask="url(#mask0_4309_9670)">
                      <path
                        d="M6.35 17.1C7.2 16.45 8.15 15.9375 9.2 15.5625C10.25 15.1875 11.35 15 12.5 15C13.65 15 14.75 15.1875 15.8 15.5625C16.85 15.9375 17.8 16.45 18.65 17.1C19.2333 16.4167 19.6875 15.6417 20.0125 14.775C20.3375 13.9083 20.5 12.9833 20.5 12C20.5 9.78333 19.7208 7.89583 18.1625 6.3375C16.6042 4.77917 14.7167 4 12.5 4C10.2833 4 8.39583 4.77917 6.8375 6.3375C5.27917 7.89583 4.5 9.78333 4.5 12C4.5 12.9833 4.6625 13.9083 4.9875 14.775C5.3125 15.6417 5.76667 16.4167 6.35 17.1ZM12.5 13C11.5167 13 10.6875 12.6625 10.0125 11.9875C9.3375 11.3125 9 10.4833 9 9.5C9 8.51667 9.3375 7.6875 10.0125 7.0125C10.6875 6.3375 11.5167 6 12.5 6C13.4833 6 14.3125 6.3375 14.9875 7.0125C15.6625 7.6875 16 8.51667 16 9.5C16 10.4833 15.6625 11.3125 14.9875 11.9875C14.3125 12.6625 13.4833 13 12.5 13ZM12.5 22C11.1167 22 9.81667 21.7375 8.6 21.2125C7.38333 20.6875 6.325 19.975 5.425 19.075C4.525 18.175 3.8125 17.1167 3.2875 15.9C2.7625 14.6833 2.5 13.3833 2.5 12C2.5 10.6167 2.7625 9.31667 3.2875 8.1C3.8125 6.88333 4.525 5.825 5.425 4.925C6.325 4.025 7.38333 3.3125 8.6 2.7875C9.81667 2.2625 11.1167 2 12.5 2C13.8833 2 15.1833 2.2625 16.4 2.7875C17.6167 3.3125 18.675 4.025 19.575 4.925C20.475 5.825 21.1875 6.88333 21.7125 8.1C22.2375 9.31667 22.5 10.6167 22.5 12C22.5 13.3833 22.2375 14.6833 21.7125 15.9C21.1875 17.1167 20.475 18.175 19.575 19.075C18.675 19.975 17.6167 20.6875 16.4 21.2125C15.1833 21.7375 13.8833 22 12.5 22ZM12.5 20C13.3833 20 14.2167 19.8708 15 19.6125C15.7833 19.3542 16.5 18.9833 17.15 18.5C16.5 18.0167 15.7833 17.6458 15 17.3875C14.2167 17.1292 13.3833 17 12.5 17C11.6167 17 10.7833 17.1292 10 17.3875C9.21667 17.6458 8.5 18.0167 7.85 18.5C8.5 18.9833 9.21667 19.3542 10 19.6125C10.7833 19.8708 11.6167 20 12.5 20ZM12.5 11C12.9333 11 13.2917 10.8583 13.575 10.575C13.8583 10.2917 14 9.93333 14 9.5C14 9.06667 13.8583 8.70833 13.575 8.425C13.2917 8.14167 12.9333 8 12.5 8C12.0667 8 11.7083 8.14167 11.425 8.425C11.1417 8.70833 11 9.06667 11 9.5C11 9.93333 11.1417 10.2917 11.425 10.575C11.7083 10.8583 12.0667 11 12.5 11Z"
                        fill="#00B0F0"
                      />
                    </g>
                  </svg>

                  {props.userWelcome}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_4467_519)">
                      <path
                        d="M13.825 7.15833L10 10.975L6.175 7.15833L5 8.33333L10 13.3333L15 8.33333L13.825 7.15833Z"
                        fill="#00B0F0"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_4467_519">
                        <rect width="20" height="20" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
                <div className="dropdown-menu">
                  <a className="dropdown-item" href="#">
                    Item One
                  </a>
                  <a className="dropdown-item" href="#">
                    Item Two
                  </a>

                  <NavLink className="dropdown-item" to="/tos">
                    Terms of Service
                  </NavLink>
                  <button
                    className="dropdown-item"
                    onClick={() => props.handleSignInOrSignOut()}
                  >
                    {props.signUpOrSignIn}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="16"
                      viewBox="0 0 20 20"
                      fill="none"
                      style={{ marginLeft: 3 }}
                    >
                      <g clipPath="url(#clip0_4832_1164)">
                        <path
                          d="M15.8333 15.8333H4.16667V4.16667H10V2.5H4.16667C3.24167 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.24167 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V10H15.8333V15.8333ZM11.6667 2.5V4.16667H14.6583L6.46667 12.3583L7.64167 13.5333L15.8333 5.34167V8.33333H17.5V2.5H11.6667Z"
                          fill="#00B0F0"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_4832_1164">
                          <rect width="20" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </button>
                </div>
              </li>
              {props.buttonText && !props.isHeliosIframeOpen && (
                <li>
                  {" "}
                  <button
                    className="signupBtn"
                    type="submit"
                    onClick={() => props.setToggle(true)}
                  >
                    {props.buttonText}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_4467_519)">
                        <path
                          d="M13.825 7.15833L10 10.975L6.175 7.15833L5 8.33333L10 13.3333L15 8.33333L13.825 7.15833Z"
                          fill="#fff"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_4467_519">
                          <rect width="20" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </button>
                </li>
              )}
              {/* )} */}
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
